export type TColumnDependency = {
  mappingDefId: number;
  conceptUri: string | null;
  conceptTypeUri: string;
  propertyUri: string;
  columns: string[];
};

export type TTransformedColumnDep = {
  domainName: string;
  conceptName: string;
  propertyName: string;
  columns: string[];
};

export const COLUMN_DEPENDENCY_ERRORS = {
  individualColumn: {
    info: (columnName: string, hasMoreThanOneDep: boolean) =>
      `${columnName} is being used in ${hasMoreThanOneDep ? 'multiple' : 'a'} property mapping${hasMoreThanOneDep ? 's' : ''} and cannot be deselected.`,
    action: (columnName: string) =>
      `In order to deselect ${columnName}, please remove it from the following mappings.`,
  },
  multipleColumns: {
    info: `One or more columns are being used in property mappings and cannot be deselected.`,
    action: 'In order to deselect the columns, please remove them from the following mappings.',
  },
  downloadError: 'There was an error downloading the list of mappings.',
  downloadCsvFileName: 'column-mapping-dependencies',
};

export const COLUMN_DEPENDENCY_ERRORS_HEADINGS = (isSingleColumn: boolean) => [
  'Domain',
  'Concept',
  'Property',
  ...(isSingleColumn ? [] : ['Columns']),
];

export const TABLE_COL_COUNT_LOCAL_SETTING = 'tableColCount';
export const TABLE_COL_PAGE_COUNT_DEFAULT = 10;
